package com.sweetlime.dungeonamigo.presentation.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.sweetlime.dungeonamigo.util.AvatarMapper
import org.jetbrains.compose.resources.painterResource

enum class PortraitSize(val dimension: Dp) {
    SMALL(48.dp),
    MEDIUM(80.dp),
    LARGE(120.dp),
    XLARGE(200.dp),
}

@Composable
fun CharacterPortrait(
    characterClass: String,
    primaryColor: Color,
    secondaryColor: Color,
    modifier: Modifier = Modifier,
    size: PortraitSize = PortraitSize.MEDIUM,
    avatarId: String = "",
) {
    val shape: Shape = when (size) {
        PortraitSize.SMALL, PortraitSize.MEDIUM -> CircleShape
        PortraitSize.LARGE, PortraitSize.XLARGE -> RoundedCornerShape(16.dp)
    }

    val avatarResource = if (avatarId.isNotBlank()) AvatarMapper.drawableFor(avatarId) else null

    if (avatarResource != null) {
        Box(
            modifier = modifier
                .size(size.dimension)
                .clip(shape),
            contentAlignment = Alignment.Center,
        ) {
            Image(
                painter = painterResource(avatarResource),
                contentDescription = avatarId,
                modifier = Modifier.fillMaxSize(),
                contentScale = ContentScale.Fit,
            )
        }
    } else {
        // No avatar assigned yet — show initials placeholder
        Box(
            modifier = modifier
                .size(size.dimension)
                .clip(shape)
                .background(
                    brush = Brush.verticalGradient(
                        colors = listOf(
                            primaryColor.copy(alpha = 0.3f),
                            secondaryColor.copy(alpha = 0.3f),
                        )
                    )
                ),
            contentAlignment = Alignment.Center,
        ) {
            val initials = characterClass.take(1).uppercase()
            Text(
                text = initials,
                color = primaryColor,
                fontSize = (size.dimension.value * 0.35f).sp,
                fontWeight = FontWeight.Bold,
            )
        }
    }
}
